import { Card, CardBody, Col } from "reactstrap";
import { Shapes } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { SHAP, SHAPS_DATA } from "../../../../Data/UiKit/Avatars";
import { Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";

const ShapsCart = () => {
  return (
    <Col xl="4" md="6">
      <Card className="height-equal">
        <CommonCardHeader title={Shapes} span={SHAPS_DATA} />
        <CardBody className="avatar-showcase">
          <div className="avatars">
            <div className="avatar">
              <Image className="img-100 b-r-8" src={dynamicImage("avtar/4.jpg")} alt="image" />
            </div>
            {SHAP.map(({ className, src }, index) => (
              <div className="avatar" key={index}>
                <Image className={`${className} b-r-30`} src={src} alt="image" />
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ShapsCart;
